<template>

      <b-row v-if="loading">
        <b-col cols="12" class="text-center">
          <b-spinner label="Loading..."></b-spinner>
        </b-col>
      </b-row>
      <b-row v-else>
       
          <div class="table-responsive" style="max-height: 500px; overflow-y: auto;">
            <table class="table table-striped table-bordered">
              <thead>
                <tr class="text-center">
                  <th rowspan="2"></th>
                  <th colspan="5">Today</th>
                  <th colspan="5">Todate</th>
                  <th colspan="2">Target</th>
                </tr>
                <tr class="text-center">
                  <th>Purchases Kgs</th>
                  <th>Value</th>
                  <th>Loan Recovered</th>
                  <th>Net Pay</th>
                  <th>Average Price</th>
                  <th>Purchases Kgs</th>
                  <th>Value</th>
                  <th>Loan Recovered</th>
                  <th>Net Pay</th>
                  <th>Average Price</th>
                  <th>Target Kgs</th>
                  <th>% Achieved</th>
                </tr>
              </thead>
              <tbody>
                
                <tr v-for="item in purchases.areas" :key="item.id">
                  <td>{{ item.name }}</td>
                  <td>{{ item.today.weight.toLocaleString() }}</td>
                  <td>{{ item.today.value.toLocaleString() }}</td>
                  <td>{{ item.today.deductions.toLocaleString() }}</td>
                  <!-- <td>{{ item.today.value.toLocaleString() }}</td> -->
                  <td>{{ item.today.net.toLocaleString() }}</td>
                  <td v-if="item.today.weight > 0">{{ (item.today.value / item.today.weight).toLocaleString(undefined, { maximumFractionDigits: 2 }) }}</td>
                  
                  <td v-if="item.today.weight == 0">0</td>
                  <td>{{ item.daily.weight.toLocaleString() }}</td>
                  <td>{{ item.daily.value.toLocaleString() }}</td>
                  <td>{{ item.daily.deductions.toLocaleString() }}</td>
                  <td>{{ item.daily.net.toLocaleString() }}</td>
                  <td v-if="item.daily.weight > 0">{{ (item.daily.value / item.daily.weight).toLocaleString(undefined, { maximumFractionDigits: 2 }) }}</td>
                  <td v-if="item.daily.weight == 0">0</td>

                  <td>{{ (item.target).toLocaleString(undefined, { maximumFractionDigits: 0 }) }}</td>
                  <td>
                    <span v-if="item.target > 0">{{ ((item.daily.weight / item.target)*100).toLocaleString(undefined, { maximumFractionDigits: 2 }) }}</span>
                    <span v-else>{{ 0 }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
      </b-row>
</template>

<script>
import { ref, onUnmounted, onMounted, watch } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
  BCardTitle,
  BCardText,
  BForm, BFormGroup,
  BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem,
  BSpinner, BFormCheckbox, BBadge, BAlert, BFormDatepicker, BBreadcrumb, BBreadcrumbItem
} from 'bootstrap-vue'
import useLineSeriesStoreModule from '@/views/dashboard/ecommerce/useLineSeriesStoreModule'
import store from '@/store'

import vSelect from 'vue-select'

import Panel from 'primevue/panel';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import VueApexCharts from 'vue-apexcharts';
import MultiSelect from 'primevue/multiselect';

export default {
  components: {
    BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
    BCardTitle,
    BCardText,
    BForm, BFormGroup,
    BButton, BFormSelect, BFormSelectOption, BFormInput, vSelect, BDropdown, BDropdownItem,
    BSpinner, BBreadcrumb, BBreadcrumbItem,
    ValidationObserver, ValidationProvider, BFormCheckbox, BBadge, BAlert, Panel, Accordion, AccordionTab, BFormDatepicker, VueApexCharts, MultiSelect
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    const locations = ref([])
    const selectedLocationName = ref(null);
    const locationBreadcrumbs = ref([]);
    const purchases = ref({});
    const dataAll = ref([]);
    const selectedLocationId = ref(null);
    const loading = ref(true);
    const level = ref();
    const saving = ref(false)
    const filterValue = ref({
      startDate: null,
      endDate: null,
    })

    const CROMIS_STORE_MODULE_NAME = 'cromis-sale_trend'
    // Register module
    if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, useLineSeriesStoreModule)

    onMounted(async () => {
      
      console.log(dataAll.value)
    });
    
    watch(() => props.data, (newData) => {
      purchases.value = newData
      if(purchases.value){
        loading.value = false;
      }
      console.log('Updated purchases from props:', purchases.value)
    })

    const onChange = async (event) => {
      loading.value = true;

      const location = purchases.value.purchases.find(loc => loc.id === event.id);
      console.log(purchases.value.level)
      selectedLocationName.value = location ? location.name : null;
      if (location) {
        locationBreadcrumbs.value.push({ text: location.name, id: location.id });
      }
      console.log(level.value)
      let payload = {
        'location_id': event.id,
        "level": level.value
      }
      console.log(payload)

      // await store.dispatch('cromis-sale_trend/dailData', payload)
      //   .then(response => {
      //     purchases.value= response.data.data
      //     level.value = response.data.data.level
      //     console.log(level.value)
      //     console.log(response.data)
      //     loading.value = false;
      //   })
      //   .catch(error => {
      //     console.log('got error', error)
      //     loading.value = false;
      //   })
    }

    const onBreadcrumbClick = async (id, index) => {
      // Remove breadcrumbs after the clicked one
      locationBreadcrumbs.value = locationBreadcrumbs.value.slice(0, index + 1);
      selectedLocationId.value = id;
      await onChange(id);
    };

    const clearBreadcrumbs = async () => {
      loading.value = true;
      locationBreadcrumbs.value = [];
      selectedLocationId.value = null;

      await store.dispatch('cromis-sale_trend/dailData')
        .then(response => {
          purchases.value = response.data.data
          console.log(purchases.value)
          loading.value = false;
        })
        .catch(error => {
          console.log('got error', error)
          loading.value = false;
        })
    };


    const generateReport = async () => {

      filterValue.value = {
        startDate: null,
        endDate: null,
      }

    }

    return {
      purchases,
      locations,
      onBreadcrumbClick,
      clearBreadcrumbs,
      locationBreadcrumbs,
      selectedLocationName,
      locationBreadcrumbs,
      selectedLocationId,
      onChange,
      loading,
      generateReport,
      filterValue,
      saving
    }
  }
}
</script>

<style scoped>
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

.table tbody+tbody {
  border-top: 2px solid #dee2e6;
}

.table-bordered {
  border: 1px solid #dee2e6;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}

.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}
</style>
